// extracted by mini-css-extract-plugin
module.exports = {"link":"header-module--link--1g7Q7","logo":"header-module--logo--3jDIS","navigation":"header-module--navigation--2A5nu","header":"header-module--header--L1ZnK"};